import { http } from 'services/http';
import { TRIP_GET_ONE, TRIP_TASKS_GET_MANY } from 'api/query-keys.ts';
import type { TUpdateTripTaskSequenceReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IUpdateSequenceVariables extends TUpdateTripTaskSequenceReq {
  tripTaskId: number;
}

export const useTripTaskSequence = (tripId: number) => {
  return useMutationBase<unknown, unknown, IUpdateSequenceVariables>({
    mutationFn: async (variables) => {
      const res = await http.patch(`/v1/trips/${tripId}/trip-tasks/${variables.tripTaskId}/sequence`, {
        sequence: variables.sequence,
      });

      return res.data;
    },
    invalidateCallback: () => [
      [TRIP_TASKS_GET_MANY, tripId],
      [TRIP_GET_ONE, tripId],
    ],
  });
};
